import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  content: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  leftBox: {
    width: 200,
    [theme.breakpoints.down("xs")]: {
      width: "unset",
    },
  },
  rightBox: {
    flex: 1,
  },
}));

export default function ListItem({
  header,
  contentLeft,
  contentRight,
  footer,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {!!header && <Box>{header}</Box>}

      <Box className={classes.content}>
        {!!contentLeft && <Box className={classes.leftBox}>{contentLeft}</Box>}
        {!!contentRight && (
          <Box className={classes.rightBox}>{contentRight}</Box>
        )}
      </Box>
      {!!footer && <Box>{footer}</Box>}
    </Box>
  );
}
